const kneeInput = document.querySelector('#size-calculator #kneeInput');
const quadInput = document.querySelector('#size-calculator #quadInput');
const calfInput = document.querySelector('#size-calculator #calfInput');
let resultEle = document.querySelector('#size-calculator [data-result]'); //result ele;

if(kneeInput && quadInput && calfInput) {
  
  quadInput.addEventListener('input', (e) => {
    const knee = Number(kneeInput.value);
    const calf = Number(calfInput.value);
    const quad = Number(e.target.value);
    const minQuad = Number(e.target.getAttribute('min'));
    const maxQuad = Number(e.target.getAttribute('max'));
    const minKnee = Number(kneeInput.getAttribute('min'));
    const minCalf = Number(calfInput.getAttribute('min'));

    quadInput.setCustomValidity('');
    if (isNaN(quad) || quad < minQuad || quad > maxQuad) {
      // let errorMessage = `Quad measurement must be a number between ${minQuad} and ${maxQuad} cm.`;
      let errorMessage = Shopify.locale?.includes('it')
      ? `La misura del quadricipite deve essere un numero compreso tra ${minQuad} e ${maxQuad} cm.`
      : `Quad measurement must be a number between ${minQuad} and ${maxQuad} cm.`;
      quadInput.setCustomValidity(errorMessage);
      quadInput.reportValidity();
      if(resultEle) resultEle.innerHTML = ``;
      return;
    }
    if(quad >= minQuad && knee >= minKnee && calf >= minCalf){
      calculateQuadKneeSize(quad, knee, calf);  
    }
  });
  
  kneeInput.addEventListener('input', (e) => {
    const quad = Number(quadInput.value);
    const calf = Number(calfInput.value);
    const knee = Number(e.target.value);
    const minKnee = Number(e.target.getAttribute('min'));
    const maxKnee =  Number(e.target.getAttribute('max'));
    const minQuad = Number(quadInput.getAttribute('min'));
    const minCalf = Number(calfInput.getAttribute('min'));

    kneeInput.setCustomValidity('');
    if (isNaN(knee) || knee < minKnee || knee > maxKnee) {
      // let errorMessage = `Knee measurement must be a number between ${minKnee} and ${maxKnee} cm.`;
      let errorMessage = Shopify.locale?.includes('it')
      ? `La misura del ginocchio deve essere un numero compreso tra ${minKnee} e ${maxKnee} cm.`
      : `Knee measurement must be a number between ${minKnee} and ${maxKnee} cm.`;
      kneeInput.setCustomValidity(errorMessage);
      kneeInput.reportValidity();
      if(resultEle) resultEle.innerHTML = ``;
      return;
    }
    if(quad >= minQuad && knee >= minKnee && calf >= minCalf){
      calculateQuadKneeSize(quad, knee, calf);  
    }
  });

  calfInput.addEventListener('input', (e) => {
    const quad = Number(quadInput.value);
    const knee = Number(kneeInput.value);
    const calf = Number(e.target.value);
    const minCalf = Number(e.target.getAttribute('min'));
    const maxCalf = Number(e.target.getAttribute('max'));
    const minKnee = Number(kneeInput.getAttribute('min'));
    const minQuad = Number(quadInput.getAttribute('min'));

    calfInput.setCustomValidity('');
    if (isNaN(calf) || calf < minCalf || calf > maxCalf) {
      // let errorMessage = `Calf measurement must be a number between ${minCalf} and ${maxCalf} cm.`;
      let errorMessage = Shopify.locale?.includes('it')
      ? `La misura del polpaccio deve essere un numero compreso tra ${minCalf} e ${maxCalf} cm.`
      : `Calf measurement must be a number between ${minCalf} and ${maxCalf} cm.`;
      calfInput.setCustomValidity(errorMessage);
      calfInput.reportValidity();
      if(resultEle) resultEle.innerHTML = ``;
      return;
    }
    if(quad >= minQuad && knee >= minKnee && calf >= minCalf){
      calculateQuadKneeSize(quad, knee, calf);  
    }
  });
}

// function calculateQuadKneeSize(quad, knee, calf) {

//   const sizeRanges = [
//     { size: '2XS', quad: [39, 42], knee: [29, 32], calf: [30, 33] },
//     { size: 'XS',  quad: [41, 44], knee: [31, 34], calf: [32, 35] },
//     { size: 'S',   quad: [43, 46], knee: [33, 36], calf: [34, 37] },
//     { size: 'M',   quad: [45, 48], knee: [35, 38], calf: [37, 40] },
//     { size: 'L',   quad: [47, 50], knee: [37, 40], calf: [39, 42] },
//     { size: 'XL',  quad: [49, 52], knee: [39, 42], calf: [41, 44] },
//     { size: '2XL', quad: [51, 54], knee: [41, 44], calf: [43, 46] },
//     { size: '3XL', quad: [53, 56], knee: [43, 46], calf: [45, 48] },
//     { size: '4XL', quad: [55, 58], knee: [45, 48], calf: [47, 50] },
//     { size: '5XL', quad: [59, 62], knee: [47, 50], calf: [49, 52] }
//   ];

//   let recommendedSize = null;

//   // ✅ Step 1: find ALL sizes where knee fits
//   const validKneeSizes = sizeRanges.filter(range => {
//     return knee >= range.knee[0] && knee <= range.knee[1];
//   });

//   if (validKneeSizes.length === 0) {
//     return showError();
//   }

//   // ✅ Step 2: pick LARGEST size where knee fits
//   for (let i = validKneeSizes.length - 1; i >= 0; i--) {
//     const range = validKneeSizes[i];

//     const quadDiff = quad - range.quad[1];
//     const calfDiff = calf - range.calf[1];

//     // ✅ Step 3: allow ≤ 1 cm overflow
//     if (quadDiff <= 1 && calfDiff <= 1) {
//       recommendedSize = range.size;
//       break;
//     }
//   }

//   // ✅ Step 4: result
//   let recommendedSizeText;

//   if (recommendedSize) {
//     recommendedSizeText = `We recommend size ${recommendedSize}.`;
//     if (Shopify.locale == 'de') {
//       recommendedSizeText = `Wir empfehlen Größe ${recommendedSize}.`;
//     }
//     if (Shopify.locale == 'it') {
//       recommendedSizeText = `Consigliamo la taglia ${recommendedSize}.`;
//     }
//   } else {
//     recommendedSizeText = `These sleeves may not be appropriate for your specific leg shape. We recommend <a href="/pages/contact-us" target="_blank">contacting</a> our customer support for a more tailored recommendation.`;
//     if (Shopify.locale == 'de') {
//       recommendedSizeText = `Diese Sleeves sind möglicherweise nicht für die spezifische Form deiner Beine geeignet. Wir empfehlen dir, unseren <a href="/pages/contact-us" target="_blank">Kundensupport</a> für eine individuellere Empfehlung zu kontaktieren.`;
//     }
//     if (Shopify.locale == 'it') {
//       recommendedSizeText = `Queste ginocchiere potrebbero non essere adatte alla forma specifica delle tue gambe. Ti consigliamo di contattare il nostro <a href="/pages/contact-us" target="_blank">servizio clienti</a> per una raccomandazione più personalizzata.`;
//     }
//   }

//   if (resultEle) {
//     resultEle.innerHTML = recommendedSizeText;
//   }

//   function showError() {
//     let msg = `These sleeves may not be appropriate for your specific leg shape. We recommend <a href="/pages/contact-us" target="_blank">contacting</a> our customer support for a more tailored recommendation.`;
//     if (Shopify.locale == 'de') {
//       msg = `Diese Sleeves sind möglicherweise nicht für die spezifische Form deiner Beine geeignet. Wir empfehlen dir, unseren <a href="/pages/contact-us" target="_blank">Kundensupport</a> für eine individuellere Empfehlung zu kontaktieren.`;
//     }
//     if (Shopify.locale == 'it') {
//       recommendedSizeText = `Queste ginocchiere potrebbero non essere adatte alla forma specifica delle tue gambe. Ti consigliamo di contattare il nostro <a href="/pages/contact-us" target="_blank">servizio clienti</a> per una raccomandazione più personalizzata.`;
//     }
//     if (resultEle) resultEle.innerHTML = msg;
//   }
// }


function calculateQuadKneeSize(quad, knee, calf) {
  const sizeRanges = [
    { size: '2XS', quad: [39, 42], knee: [29, 32], calf: [30, 33] },
    { size: 'XS',  quad: [41, 44], knee: [31, 34], calf: [32, 35] },
    { size: 'S',   quad: [43, 46], knee: [33, 36], calf: [34, 37] },
    { size: 'M',   quad: [45, 48], knee: [35, 38], calf: [37, 40] },
    { size: 'L',   quad: [47, 50], knee: [37, 40], calf: [39, 42] },
    { size: 'XL',  quad: [49, 52], knee: [39, 42], calf: [41, 44] },
    { size: '2XL', quad: [51, 54], knee: [41, 44], calf: [43, 46] },
    { size: '3XL', quad: [53, 56], knee: [43, 46], calf: [45, 48] },
    { size: '4XL', quad: [55, 58], knee: [45, 48], calf: [47, 50] },
    { size: '5XL', quad: [59, 62], knee: [47, 50], calf: [49, 52] }
  ];
  let recommendedSize = null;
  // Step 1: find ALL sizes where knee fits
  const validKneeSizes = sizeRanges.filter(range => {
    return knee >= range.knee[0] && knee <= range.knee[1];
  });
  if (validKneeSizes.length === 0) {
    return showError();
  }
  // NEW: first prefer the largest size where ALL measurements fit fully
  const exactMatchSizes = validKneeSizes.filter(range => {
    return (
      quad >= range.quad[0] && quad <= range.quad[1] &&
      calf >= range.calf[0] && calf <= range.calf[1]
    );
  });
  if (exactMatchSizes.length > 0) {
    recommendedSize = exactMatchSizes[exactMatchSizes.length - 1].size;
  } else {
    // Original behavior: pick largest knee-valid size with <= 1 cm overflow
    for (let i = validKneeSizes.length - 1; i >= 0; i--) {
      const range = validKneeSizes[i];
      const quadDiff = quad - range.quad[1];
      const calfDiff = calf - range.calf[1];
      if (quadDiff <= 1 && calfDiff <= 1) {
        recommendedSize = range.size;
        break;
      }
    }
  }
  let recommendedSizeText;
  if (recommendedSize) {
    recommendedSizeText = `We recommend size ${recommendedSize}.`;
    if (Shopify.locale == 'de') {
      recommendedSizeText = `Wir empfehlen Größe ${recommendedSize}.`;
    }
    if (Shopify.locale == 'it') {
      recommendedSizeText = `Consigliamo la taglia ${recommendedSize}.`;
    }
  } else {
    recommendedSizeText = `These sleeves may not be appropriate for your specific leg shape. We recommend <a href="/pages/contact-us" target="_blank">contacting</a> our customer support for a more tailored recommendation.`;
    if (Shopify.locale == 'de') {
      recommendedSizeText = `Diese Sleeves sind möglicherweise nicht für die spezifische Form deiner Beine geeignet. Wir empfehlen dir, unseren <a href="/pages/contact-us" target="_blank">Kundensupport</a> für eine individuellere Empfehlung zu kontaktieren.`;
    }
    if (Shopify.locale == 'it') {
      recommendedSizeText = `Queste ginocchiere potrebbero non essere adatte alla forma specifica delle tue gambe. Ti consigliamo di contattare il nostro <a href="/pages/contact-us" target="_blank">servizio clienti</a> per una raccomandazione più personalizzata.`;
    }
  }
  if (resultEle) {
    resultEle.innerHTML = recommendedSizeText;
  }
  function showError() {
    let msg = `These sleeves may not be appropriate for your specific leg shape. We recommend <a href="/pages/contact-us" target="_blank">contacting</a> our customer support for a more tailored recommendation.`;
    if (Shopify.locale == 'de') {
      msg = `Diese Sleeves sind möglicherweise nicht für die spezifische Form deiner Beine geeignet. Wir empfehlen dir, unseren <a href="/pages/contact-us" target="_blank">Kundensupport</a> für eine individuellere Empfehlung zu kontaktieren.`;
    }
    if (Shopify.locale == 'it') {
      msg = `Queste ginocchiere potrebbero non essere adatte alla forma specifica delle tue gambe. Ti consigliamo di contattare il nostro <a href="/pages/contact-us" target="_blank">servizio clienti</a> per una raccomandazione più personalizzata.`;
    }
    if (resultEle) resultEle.innerHTML = msg;
  }
}
